import { Stack, Typography } from "@mui/material";
import { Handle, Position } from "@xyflow/react";

import type { ReactionRuleNode, RuleNodeProps } from "../types/nodes";
import { useRuleScreenFieldDisplay } from "./rule-screen-field-display-context";
import BaseNode from "./BaseNode";

type ReactionNodeProps = RuleNodeProps<ReactionRuleNode>;

const ReactionNode = (props: ReactionNodeProps) => {
	const { data } = props;
	const screenFieldDisplay = useRuleScreenFieldDisplay();

	const screenFieldLabel = (() => {
		const raw = data.screenFieldName || data.screenFieldId;
		if (!raw) return undefined;
		if (typeof raw !== "string" || !screenFieldDisplay) return raw;
		return screenFieldDisplay.formatScreenFieldLabel(
			raw,
			typeof data.screenFieldId === "string" ? data.screenFieldId : undefined,
		);
	})();

	const details = [
		{ label: "Type of Reaction", value: data.reactionTypeFriendlyName },
		{ label: "Reaction Location", value: data.screenLocation },
		{ label: "Field", value: screenFieldLabel },
	].filter((detail) => {
		if (detail.value === undefined) {
			return false;
		}
		if (typeof detail.value === "string") {
			return detail.value.trim().length > 0;
		}
		return Boolean(detail.value);
	});

	return (
		<BaseNode {...props}>
			{details.length ? (
				<Stack spacing={0.5}>
					{details.map((detail) => (
						<Stack
							key={detail.label}
							direction="row"
							spacing={0.5}
							sx={{alignItems: "baseline", flexWrap: "wrap"}}
						>
							<Typography variant="body2" color="text.secondary" sx={{fontWeight: 600}}>
								{detail.label}:
							</Typography>
							<Typography variant="body2" color="text.primary">
								{detail.value as string}
							</Typography>
						</Stack>
					))}
				</Stack>
			) : (
				<Typography variant="body2" color="text.disabled">
          No reaction details set
				</Typography>
			)}
			<Handle type="target" position={Position.Top} id="in" />
		</BaseNode>
	);
};

export default ReactionNode;
